import noop from "lodash/noop";
import React from "react";
import { withTranslation } from "react-i18next";
import { RillContext } from "../../rill/RillReact/share/base";

class ImageUploadInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modified: false,
      src: undefined,
      hovering: false,
    };
    // this.handleReset = this.handleReset.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleReset(e) {
    if (e && e.target && e.target.hasAttribute("data-noreset")) return;
    this.setState({ src: undefined, modified: false });
  }

  handleChange({ target }) {
    if (!target.value) {
      return false;
    } else {
      // extract file
      const file = target.files[0];

      // setup file reader
      const fileReader = new FileReader();

      // store the image in state once it's loaded off the file system
      fileReader.onload = (event) => {
        this.setState({
          src: event.target.result,
          modified: true,
        });
      };

      // handle the error...kind of.
      fileReader.onerror = (event) => {
        console.error(
          "File could not be read! Code " + event.target.error.code
        );
      };

      // finally read the file
      fileReader.readAsDataURL(file);
    }
  }

  componentWillMount() {
    const fullImagePath = this.props.defaultValue?.file
      ? `/api/file/${this.props.defaultValue.file}`
      : this.props.defaultValue;
    this.setState({ src: fullImagePath });
  }

  render() {
    const { locals } = this.context;
    const { t, name, raw, prefix, required = false } = this.props;
    const { modified, src } = this.state;
    const defaultValue = this.props.defaultValue.file;

    return !raw ? (
      <div className="image-input">
        <div
          className="image"
          style={{ backgroundImage: `url(${src || defaultValue})` }}
        ></div>

        <label>
          <span className="text">{t("uploadImage")}</span>
          <input
            key={defaultValue}
            ref="input"
            id="file-input"
            className="file-input"
            {...this.props}
            type="file"
            accept="image/*"
            required={!defaultValue && this.props.required}
            onChange={this.handleChange}
            defaultValue={undefined}
          />
        </label>

        {!modified && defaultValue && (
          <input
            type="hidden"
            name={`${name}[file]`}
            value={defaultValue}
            onChange={noop}
          />
        )}
      </div>
    ) : (
      <div className="image-input">
        {/* <div className={`label${required ? " req" : ""}`}>{prefix} image</div> */}
        <label
          htmlFor="file-input"
          className="photo-upload"
          style={{
            background: !modified ? "" : `center / cover no-repeat url(${src})`,
            opacity: this.state.hovering ? 0.8 : 1,
          }}
          onMouseEnter={() => this.setState({ hovering: true })}
          onMouseLeave={() => this.setState({ hovering: false })}
        >
          {!modified && (
            <>
              <p>{t("uploadImage")}</p>
              <p className="p4">{t("imageFormat169")}</p>
            </>
          )}
          {modified && this.state.hovering && (
            <>
              <p>{t("uploadImage")}</p>
              <p className="p4">{t("imageFormat169")}</p>
            </>
          )}
        </label>
        <input
          key={1}
          ref="input"
          name={name}
          id="file-input"
          type="file"
          accept="image/*"
          onChange={this.handleChange}
          defaultValue={undefined}
        />
        {!modified && defaultValue && (
          <input
            type="hidden"
            name={`${name}[file]`}
            value={defaultValue}
            onChange={noop}
          />
        )}
      </div>
    );
  }
}

ImageUploadInput.defaultProps = {
  defaultValue: {},
};

ImageUploadInput.contextType = RillContext;

export default withTranslation("common")(ImageUploadInput);
